import { createContext, useContext } from 'react'
import useCarrinho from './hooks/useCarrinho'

export type CartContextType = ReturnType<typeof useCarrinho>

export const CartContext = createContext({} as CartContextType)

export type CartContextProviderProps = { children?: React.ReactNode }

export const CartContextProvider = ({ children }: CartContextProviderProps) => {
  return (
    <CartContext.Provider value={useCarrinho()}>
      {children}
    </CartContext.Provider>
  )
}

export const useCartContext = () => useContext(CartContext)
